// Helpers
import { getOutlinedPositionIcon } from "@/Common/helpers/Positions/icons";

// Layouts
import PageLayer from "@/Layouts/views/PageLayer";
import SalesManagerWashoutLayer from "@/Washouts/views/Layers/Sales/Managers/SalesManagerWashoutLayer";

const POSITION = "Sales Manager";

export default function SalesManagerWashout() {
	const Icon = getOutlinedPositionIcon({ position: POSITION });
	return (
		<PageLayer title={"Sales Managers Washouts"} icon={Icon}>
			<SalesManagerWashoutLayer />
		</PageLayer>
	);
}
